import { render, staticRenderFns } from "./project-images.vue?vue&type=template&id=36def39e"
import script from "./project-images.vue?vue&type=script&lang=js"
export * from "./project-images.vue?vue&type=script&lang=js"
import style0 from "./project-images.vue?vue&type=style&index=0&id=36def39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports